// extracted by mini-css-extract-plugin
export default {"MobileLayout":"MobileLayout_MobileLayout__X1gj2","toggleOption":"MobileLayout_toggleOption__PK7Py"};